import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
const _c0 = ["ycn-background-jobs-progress-popover-item", ""];
const _c1 = a0 => ({ active: a0 });
function BackgroundJobsProgressPopoverItemComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.progress.description);
} }
export class BackgroundJobsProgressPopoverItemComponent {
    constructor() {
        this.showDescription = false;
    }
    toggleShowDescription() {
        this.showDescription = !this.showDescription;
    }
}
BackgroundJobsProgressPopoverItemComponent.ɵfac = function BackgroundJobsProgressPopoverItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BackgroundJobsProgressPopoverItemComponent)(); };
BackgroundJobsProgressPopoverItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BackgroundJobsProgressPopoverItemComponent, selectors: [["tr", "ycn-background-jobs-progress-popover-item", ""]], inputs: { progress: "progress" }, standalone: false, attrs: _c0, decls: 6, vars: 5, consts: [[1, "pl-20", "pr-20"], ["data-toggle", "collapse", 1, "notification-title", "d-flex", "cursor-pointer", 3, "ngClass"], [1, "d-inline-block", "mr-1", "collapse-chevron", "collapse-chevron-small", 3, "click"], ["class", "text-gray-50", 4, "ngIf"], [1, "text-gray-50"]], template: function BackgroundJobsProgressPopoverItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "td", 0)(1, "div", 1)(2, "span", 2);
        i0.ɵɵlistener("click", function BackgroundJobsProgressPopoverItemComponent_Template_span_click_2_listener() { return ctx.toggleShowDescription(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "span");
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(5, BackgroundJobsProgressPopoverItemComponent_div_5_Template, 2, 1, "div", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1, ctx.showDescription));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.progress.title);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showDescription);
    } }, dependencies: [i1.NgClass, i1.NgIf], encapsulation: 2 });
